import LoopFront, { TAction } from "loop-front";
import { TToastConfig, AppState } from "./@types";
import { ThunkAction } from "redux-thunk";
import { ReduxStore } from "../../stores";
import utilities from "../../../src/Resources/Utils";
import { OUser } from "../Users/Model";
import { ActionCreator } from "Typings/Global";
import { OTag } from "Models/Tag";

const CustomActions = {
    OPEN_TOAST: 'OPEN_TOAST',
    CLOSE_TOAST: 'CLOSE_TOAST',
    TOGGLE_APP_LINEAR_LOADER: 'TOGGLE_APP_LINEAR_LOADER',
    OPEN_CONFIRMATION_DIALOG: 'OPEN_CONFIRMATION_DIALOG',
    CLOSE_CONFIRMATION_DIALOG: 'CLOSE_CONFIRMATION_DIALOG'
}

class AppModel extends LoopFront<typeof CustomActions> {
    constructor() {
        super('app', CustomActions);
    }

    init = (): ThunkAction<Promise<boolean>, ReduxStore, {}, TAction> => async (dispatch, getState) => {
        const access_token = utilities.getAccessToken();
        const userId = utilities.getUserId();
        if (access_token && userId) {
            LoopFront.setAuthHeader(access_token);
            const res = await OUser.requestGetItem(userId).catch(error => {
                console.log('Getting Me Error', error);
                LoopFront.setAuthHeader('');
                utilities.clearCookies();
                throw error
            });
            dispatch({ type: OUser.Actions.APP_USER_RECEIVED, data: res.data });
            dispatch(OTag.getItemsList());
            return Promise.resolve(true);
        }
        return Promise.resolve(false);
    }

    showToast = (toastConfig: TToastConfig): ActionCreator => (dispatch, getState) => {
        const { toast = {} } = getState().App;
        if (toast.open) return;
        dispatch({ type: this.Actions.OPEN_TOAST, data: { ...toastConfig, open: true } })
    }

    closeToast = (): ActionCreator => (dispatch, getState) => {
        const { toast = {} } = getState().App;
        if (!toast.open) return;
        dispatch({ type: this.Actions.CLOSE_TOAST })
    }

    toggleLinearAppLoader = (flag: boolean): ActionCreator => (dispatch) => dispatch({ type: this.Actions.TOGGLE_APP_LINEAR_LOADER, data: flag });

    showConfirmationDialog = (config: AppState['confirmationDialogConfig']): ActionCreator => dispatch => dispatch({ type: this.Actions.OPEN_CONFIRMATION_DIALOG, data: config });
    hideConfirmationDialog = (): ActionCreator => dispatch => dispatch({ type: this.Actions.CLOSE_CONFIRMATION_DIALOG, data: { open: false, title: '', message: '' } });

}
export const OApp = new AppModel();